import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconCarCheckmark = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24h-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M18 14l-1.74846e-07 3.55271e-15c2.20914-9.65645e-08 4 1.79086 4 4 9.65645e-08 2.20914-1.79086 4-4 4 -2.20914 9.65645e-08-4-1.79086-4-4l4.61853e-14 6.03983e-07c-3.33571e-07-2.20914 1.79086-4 4-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M19.348 17.327l-1.684 1.689 -1.012-1.016"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M8.324 11.471h-2.118"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M16.853 11.471h-2.118"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M17.912 8.294l2.117-1.059"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M5.147 8.294l-2.118-1.059"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M8.084 3l-1.03477e-09 1.07025e-13c-.984139.000101641-1.83868.677767-2.063 1.636l-.9 3.84 .9-3.84 2.98488e-08-1.27504e-07c.224323-.958233 1.07886-1.6359 2.063-1.636h6.891l9.20664e-08-1.59859e-11c.984023-.000170839 1.83842.677714 2.062 1.636l.9 3.84"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M20.029 12v-.79l1.40332e-12-2.82386e-06c0-1.56306-1.26594-2.83079-2.829-2.833h-11.337l-1.3518e-07-4.77112e-11c-1.56462-.00055221-2.83345 1.26738-2.834 2.832 -1.17666e-07.000333393-1.76481e-07.000666787-1.76444e-07.00100018v4.79l1.19904e-14 1.50996e-07c8.33927e-08.552285.447715 1 1 1 0 0 8.88178e-16 0 8.88178e-16 0h2.236 -4.37114e-08c.552285 2.41411e-08 1-.447715 1-1v-1.353h4.735"
  })));
};
//# sourceMappingURL=IconCarCheckmark.js.map